import { z } from 'zod';

export const rewardsProgramModelSchema = z.object({
  id: z.string(),
  type: z.literal('rewards_program'),
  attributes: z.object({
    description: z.string(),
    externalLink: z.string(),
    data: z.object({
      requiresAutoRedemptionDetails: z.boolean(),
    }),
  }),
  relationships: z
    .object({
      loyaltyProgram: z.object({
        data: z.object({
          id: z.string(),
          type: z.literal('loyalty_program'),
        }),
      }),
    })
    .optional(),
});

export const rewardsProgramPreferenceModelSchema = z.object({
  id: z.string(),
  type: z.literal('rewards_program_preference'),
  relationships: z.object({
    rewardsProgram: z.object({
      data: z.object({
        id: z.string(),
        type: z.literal('rewards_program'),
      }),
    }),
    user: z.object({
      data: z.object({
        id: z.string(),
        type: z.literal('user'),
      }),
    }),
  }),
});
